import { render } from "./BusDeviceCard.vue?vue&type=template&id=bfbb52ba&scoped=true"
import script from "./BusDeviceCard.vue?vue&type=script&lang=js"
export * from "./BusDeviceCard.vue?vue&type=script&lang=js"

import "./BusDeviceCard.vue?vue&type=style&index=0&id=bfbb52ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbb52ba"]])

export default __exports__